var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57778 4.44444H5.77847C5.65521 4.44444 5.55556 4.34444 5.55556 4.22153V0.422222C5.55556 0.188889 5.36667 0 5.13333 0H4.86667C4.63333 0 4.44444 0.188889 4.44444 0.422222V4.22153C4.44444 4.34479 4.34444 4.44444 4.22153 4.44444H0.422222C0.188889 4.44444 0 4.63333 0 4.86667V5.13333C0 5.36667 0.188889 5.55556 0.422222 5.55556H4.22153C4.34479 5.55556 4.44444 5.65556 4.44444 5.77847V9.57778C4.44444 9.81111 4.63333 10 4.86667 10H5.13333C5.36667 10 5.55556 9.81111 5.55556 9.57778V5.77847C5.55556 5.65521 5.65556 5.55556 5.77847 5.55556H9.57778C9.81111 5.55556 10 5.36667 10 5.13333V4.86667C10 4.63333 9.81111 4.44444 9.57778 4.44444Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.0e9fe12358740411ac865840a74be274.svg";
export { ForwardRef as ReactComponent };